import { AttrViewStylesNames } from "./ZAttrViewStyles";
import { ZAttrComponentView } from "./zAttrViewInfo";

export const viewStylesByType = {
  SimpleText: ["fontWeight", "textAlign"],
  PersonCellInfo: ["fontWeight", "textAlign"],
  DictRef: ["fontWeight", "textAlign"],
  ObectRef: ["fontWeight", "textAlign"],
  ImgList: ["maxHeight"],
  LinkStd: ["fontWeight", "textAlign"],
  LinkView: ["fontWeight", "textAlign"],
  Tag: ["fontWeight", "textAlign"],
  FileList: ["fontWeight", "textAlign"],
  ContentLangInfo: [],
  AttrLinked: [],
  ChildEntitiesCellInfo: [],
  AttrFormulaCell: [],
  ArticleView: [],
  FinancialView: [],
  FormulaWithFinancialView: [],
  ColorView: [],
} satisfies Record<ZAttrComponentView["view"], AttrViewStylesNames[]>;
